import React from "react";
import "./PullPlanTabs.css";

export type PullPlanTab = "sections" | "history";

interface Props {
  active: PullPlanTab;
  onChange: (next: PullPlanTab) => void;
}

const TABS: Array<{ id: PullPlanTab; label: string }> = [
  { id: "sections", label: "Sections" },
  { id: "history", label: "History" },
];

const PullPlanTabs: React.FC<Props> = ({ active, onChange }) => (
  <div className="pull-plan-tabs" role="tablist">
    {TABS.map((tab) => {
      const isActive = active === tab.id;
      return (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={isActive}
          className={`pull-plan-tab-btn${isActive ? " pull-plan-tab-btn--active" : ""}`}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
        </button>
      );
    })}
  </div>
);

export default PullPlanTabs;
